/* Svensk katalog for locale-autopilot-followup.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'ap.skip.title': 'Hoppa över uppföljning',
  'ap.skip.nextMonth': 'Påminn mig nästa månad',
  'ap.skip.always': 'Ignorera den här punkten',
  'ap.skip.help': 'Skjut upp punkten till nästa månad, eller ignorera just den här punkten. Nya fakturor, kunder och andra nya fynd visas fortfarande.',
  'ap.skip.itemFallback': 'Den här uppföljningspunkten',
  'ap.skip.all': 'Hoppa över alla',
  'ap.skip.allInvoices': 'Alla dokument i den här listan',
  'ap.skip.allCustomers': 'Alla kunder i den här listan',
  'ap.agent.followup.title': 'Uppföljningsagenten',
  'ap.agent.followup.detail': 'Fångar upp uppgifter och avvikelser som inte hör till en inlämningsagent.',
  'ap.permission.followup.label': 'Uppföljningsagenten',
  'ap.permission.followup.desc': 'Fångar upp uppgifter, kunddialoger och avvikelser som inte hör till en inlämningsagent.',
  'ap.lineIgnoredToast': 'Den här punkten ignoreras. Nya uppföljningspunkter visas fortfarande.',
  'ap.linesSkippedToast': '{{count}} punkter har hoppats över.',
  'ap.followup.correctionOne': '{{count}} fel måste korrigeras.',
  'ap.followup.correctionMany': '{{count}} fel måste korrigeras.',
  'ap.followup.correctionDetailOne': '{{count}} punkt måste korrigeras',
  'ap.followup.correctionDetailMany': '{{count}} punkter måste korrigeras',
  'ap.followup.mustCorrect': 'Måste korrigeras',
  'ap.followup.correct': 'Korrigera',
  'ap.followup.correctInSettings': 'Korrigera i inställningar',
});
